import { Plugins } from '@leverege/plugin';
const processor = plgs => {
  const byDelegateTypeAndObjectType = new Map();
  const byObjectType = new Map();
  const byDelegateType = new Map();
  for (let i = 0; i < plgs.length; i++) {
    const plg = plgs[i];
    if (plg == null || typeof plg.delegateType !== 'string' && typeof plg.objectType !== 'string') {
      continue;
    }
    const {
      delegateType,
      objectType
    } = plg;
    if (delegateType && objectType) {
      byDelegateTypeAndObjectType.set(getKey({
        delegateType,
        objectType
      }), plg);
      byObjectType.set(getKey({
        objectType
      }), plg);
      byDelegateType.set(getKey({
        delegateType
      }), plg);
    } else if (objectType) {
      byObjectType.set(getKey({
        objectType
      }), plg);
    } else {
      byDelegateType.set(getKey({
        delegateType
      }), plg);
    }
  }
  return {
    byDelegateTypeAndObjectType,
    byObjectType,
    byDelegateType
  };
};
function getKey({
  delegateType,
  objectType
}) {
  if (delegateType && objectType) {
    return `${delegateType}:${objectType}`;
  }
  if (objectType) {
    return objectType;
  }
  if (delegateType) {
    return delegateType;
  }
  return null;
}
function create(pluginPoint, funcName = `get${pluginPoint}For`) {
  const view = Plugins.createView(pluginPoint, {
    processor
  });
  function getItemFor(delegateType, objectType) {
    const {
      byDelegateTypeAndObjectType,
      byObjectType,
      byDelegateType
    } = view.get();
    return byDelegateTypeAndObjectType.get(getKey({
      delegateType,
      objectType
    })) || byObjectType.get(getKey({
      objectType
    })) || byDelegateType.get(getKey({
      delegateType
    })) || null;
  }
  return {
    [funcName]: getItemFor
  };
}
export default {
  create
};